import type { SiteConfig } from '../../@types/context/site-config.types';

export const sitePathDefaultsConfig: Pick<SiteConfig, 'path'> = {
  path: {
    loansApply: '/loans/apply',
    mypage: '/mypage',
    securedLoansApply: '/secured-loans/apply',
    securedLoansMypage: '/mypage/secured-loans',
    discoveryLoansApply: '/discovery-loans/apply',
    discoveryLoansSuggestions: '/discovery-loans/suggestions',
    insurance: '/insurance/apply',
  },
};
